import { action } from 'satcheljs';
import { ServiceCallLog } from '..';

/**
 * Action which logs the service call for diagnostics panel
 */
export const logServiceCallForDiagnostics = action(
    'logServiceCallForDiagnostics',
    (serviceCall: ServiceCallLog) => ({ serviceCall })
);
